import React, { Fragment } from "react";
import { Route, Navigate, Routes, useLocation } from "react-router-dom";
import HomePage from "../../homePage/index";
import Header from "../../layout/Header/index";
import { useSelector } from "react-redux";
import PreAuthLayout from "../PreAuth/index";
import PostAuthLayout from "../PostAuth/index";
import CustomerAuth from "../PostAuth/CustomerAuth";
import DeliveryAuth from "../PostAuth/DeliveryAuth";
import DeliveryPage from "../../deliveryPage";
import BusinessPage from "../../businessPage";
import Support from "../../homePage/Support";
import Marketing from "../../homePage/Marketing";
import OAuthSuccess from "../../auth/signUpOnboard/oAuthSuccess";
import DocumentTitle from "../../component/DocumentTitle";
import AnalyticsTracker from "../../component/AnalyticsTracker";
import PrivacyPolicy from "../../homePage/PrivacyPolicy";
import DeleteAccount from "../../homePage/DeleteAccount";
import { isPublicEndpoint } from "../../constants/seo";

const RequireAuth = ({ children }) => {
  const { loginDetails } = useSelector((state) => state.counter);
  const isAuthenticated = !!loginDetails?.jwt;

  if (!isAuthenticated) {
    return <Navigate to="/auth/account" replace />;
  }

  return children;
};

const AppMain = () => {
  const location = useLocation();
  const isSidebarOpen = useSelector((state) => state.layout.isSidebarOpen);
  const isPreAuthRoute =
    isPublicEndpoint(location.pathname) ||
    location.pathname.startsWith("/auth");
  return (
    <Fragment>
      <DocumentTitle />
      <AnalyticsTracker />
      <Header isPreAuthRoute={isPreAuthRoute} />
      <Routes>
        <Route path="/" element={<HomePage />} exact />
        <Route path="/support" element={<Support />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/delivery-partner" element={<DeliveryPage />} />
        <Route path="/laundry-business" element={<BusinessPage />} />
        <Route path="/auth/*" element={<PreAuthLayout />} />
        <Route path="/delivery/*" element={<DeliveryAuth />} />
        <Route path="login-success" element={<OAuthSuccess />} />
       <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />

        <Route
          path="/app/*"
          element={
            <RequireAuth>
              <PostAuthLayout />
            </RequireAuth>
          }
        />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <CustomerAuth />
            </RequireAuth>
          }
        />
        {/* <Route
          path="/delivery/*"
          element={
            <RequireAuth>
              <DeliveryAuth />
            </RequireAuth>
          }
        /> */}
      </Routes>
    </Fragment>
  );
};

export default AppMain;
